<template>
  <div class="cs-coursewareList">
    <el-row class="cs-coursewareList-top">
      <el-col :span="4" v-if="courseType == 1">
        <el-select v-if="!USERMANAGER.isStudent" @change="getListData()" placeholder="学期" v-model="searchCondition.termId" size="medium">
          <el-option v-for="item in termList" :key="item.Id" :label="item.DisplayLable" :value="item.Id"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4" v-if="
          courseType == 1 &&
          (USERMANAGER.isAdmin ||
            USERMANAGER.isAcademicAffairs ||
            USERMANAGER.isRegionCEO ||
            USERMANAGER.isCampusPresident)
        ">
        <el-select @change="getListData()" placeholder="请选择" size="medium" v-model="searchCondition.groupNumber" class="margin-left-20px">
          <el-option v-for="item in universityGroups" :key="item.IdValue" :label="item.NameValue" :value="item.GroupNumber"></el-option>
        </el-select>
      </el-col>

      <el-col :span="4" v-if="courseType == 3">
        <el-select @change="changeCourseCategory()" placeholder="职业类型" size="medium" v-model="searchCondition.courseCategory">
          <el-option v-for="item in courseCategories" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4" v-if="courseType == 3">
        <el-select v-if="!USERMANAGER.isStudent" @change="getListData()" placeholder="学期" v-model="searchCondition.termId" size="medium"
          class="margin-left-20px">
          <el-option v-for="item in vocationalTrainingTermList" :key="item.Id" :label="item.DisplayLable" :value="item.Id"></el-option>
        </el-select>
      </el-col>
      <el-col :offset="4" :span="10" v-if="!USERMANAGER.isStudent">
        <el-date-picker class="cs-coursewareList-searchDate" v-model="searchDate" type="daterange" align="center" unlink-panels range-separator="-"
          start-placeholder="开始" end-placeholder="结束" :picker-options="pickerOptions" size="medium"></el-date-picker>

        <el-button type="primary" :loading="isDownloading" :disabled="isDownloading || isCourseDownloading" size="small" @click="onDownload">一键下载</el-button>

        <el-button v-if="USERMANAGER.isAdmin" type="primary" v-loading="isTesting" element-loading-text="测试中" element-loading-spinner="el-icon-loading"
          :disabled="isTesting" size="small" @click="onTesting">测试</el-button>
      </el-col>
    </el-row>
    <pagination v-loading="loading" :data="listData" :option="paginationOption" @customEvent="customEventHandler" @additional="onAdditional"></pagination>
    <el-dialog title="测试" :center="true" :close-on-click-modal="false" width="600px" :visible.sync="displayTesting" top="5vh">
      <div class="backgroud-white">
        <div class="cs-coursewareFile-message-main">
          <el-input-number v-model="testingCount" :min="1" :max="1000" :step="10" size="small" style="width: 200px">
          </el-input-number>
        </div>
        <div class="cs-coursewareFile-message-footer">
          <el-button round type="primary" size="middle" @click="onCloseTesting">确认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss">
.cs-coursewareList {
  /deep/ .el-loading-spinner {
    margin-top: -15px;
  }
  /deep/ .el-loading-spinner .el-loading-text {
    font-size: 12px;
  }
  .current-term-container {
    //display:table-cell;
    height: 36px;
  }
  .current-term {
    padding-left: 20px;
    vertical-align: middle;
  }
  .cs-coursewareList-top {
    .el-button {
      vertical-align: middle;
    }
    .cs-coursewareList-searchDate {
      width: 250px !important;
    }
  }
}

.cs-coursewareFile-message-main {
  padding: 1rem 2rem 1rem 2rem;
}
.cs-coursewareFile-message-footer {
  text-align: center;
  margin-top: 2rem;
  margin-bottom: 2rem;
  button {
    width: 200px;
  }
}
</style>

<script>
import {
  getUniversityGroups,
  getTerms,
  getTrainingCategoryList,
  getTrainingTerms,
} from "../../service/common.service";
import {
  getcoursewareList,
  downloadCourseware,
  getTotalFilesInfo,
} from "../../service/courseware.service";
import pagination from "../common/pagination";
import { formatDate, downloadFile, sleep } from "../../config/mUtils";
import global_ from "@/core/global";

export default {
  data() {
    return {
      displayTesting: false,
      testingCount: 10,
      isTesting: false,
      isDownloading: false,
      isCourseDownloading: false,
      loading: false,
      listData: {},
      paginationOption: {},
      universityGroups: [],
      searchCondition: {
        groupNumber: "",
        termId: "",
        courseCategory: "",
      },
      searchDate: [],
      courseCategories: [],
      currentTerm: {},
      termList: [],
      vocationalTrainingTermList: [],
      pageSize: 20,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  components: {
    pagination,
  },
  props: {
    courseType: Number,
  },
  created() {
    const additionalColumns = [];
    if (this.USERMANAGER.isAdmin || this.USERMANAGER.isAcademicAffairs) {
      additionalColumns.push({
        name: "Download",
        title: "",
        buttonText: "下载",
        fnDisabled: (index, row) => {
          return (
            row._isDownloading || this.isCourseDownloading || this.isDownloading
          );
        },
        fnLoading: (index, row) => {
          return !!row._isDownloading;
        },
      });
    }

    this.paginationOption = {
      displayPagination: false,
      hasEditButton: false,
      hasAddButton: false,
      addButtonText: "",
      hasSearch: false,
      showAcitveColor: true,
      hideDisableRow: true,
      displayTeacher: !this.USERMANAGER.isStudent,
      displayUniversityGroup: this.courseType == 1,
      displayCampus: this.courseType == 3,
      additionalColumns,
    };

    if (this.courseType == 1) {
      getTerms(false, true, true).then((result) => {
        if (!!result && result.success) {
          this.termList = result.data;

          if (this.termList.length > 0) {
            this.currentTerm = result.data.find((i) => i.IsCurrentTerm);
            if (this.USERMANAGER.isStudent && !this.currentTerm) {
              this.searchCondition.termId = "";
            } else {
              if (!!this.currentTerm) {
                this.searchCondition.termId = this.currentTerm.Id;
              } else {
                this.searchCondition.termId = this.termList[0].Id;
              }
            }
          }
          this.getListData();
        }
      });
      if (
        this.USERMANAGER.isAdmin ||
        this.USERMANAGER.isAcademicAffairs ||
        this.USERMANAGER.isRegionCEO ||
        this.USERMANAGER.isCampusPresident
      ) {
        this.loadUniversityGroups(() => {
          this.setGroupNumber();
          this.getListData();
        });
      } else {
        this.searchCondition.groupNumber = -1;
      }
    } else if (this.courseType == 3) {
      getTrainingCategoryList(3, true).then((result) => {
        if (!!result && result.success) {
          this.courseCategories = result.data;
          if (this.courseCategories.length > 0) {
            this.searchCondition.courseCategory = this.courseCategories[0].Id;
            this.changeCourseCategory();
          }
        }
      });
    }

    this.searchDate = [];
    let today = new Date();
    this.searchDate.push(today);
    this.searchDate.push(today);
  },
  methods: {
    onCloseTesting() {
      this.displayTesting = false;
      this.$message("测试将在3秒后发起，次数 " + this.testingCount);
      setTimeout(() => {
        for (let i = 0; i < this.testingCount; i++) {
          this.getListData();
        }
      }, 3000);
    },
    onTesting() {
      this.displayTesting = true;
    },
    nav(data) {
      this.$router.push({
        path: "/coursewareWeekly",
        query: {
          courseType: this.courseType,
          campusId: data.CampusId,
          courseId: data.CourseId,
          courseName: data.CourseName,
        },
      });
    },
    setGroupNumber() {
      let groupNumber = this.$route.query.groupNumber;

      if (groupNumber && groupNumber > 0) {
        this.searchCondition.groupNumber = parseInt(groupNumber);
      } else {
        if (!!this.universityGroups && this.universityGroups.length > 0) {
          this.searchCondition.groupNumber =
            this.universityGroups[0].GroupNumber;
        }
      }
    },
    loadUniversityGroups(callback) {
      getUniversityGroups().then((result) => {
        if (!!result && result.success) {
          this.universityGroups = result.data;
          if (!!callback) {
            callback();
          }
        }
      });
    },
    changeCourseCategory() {
      getTrainingTerms(false, this.searchCondition.courseCategory, true).then(
        (result) => {
          if (!!result && result.success) {
            this.vocationalTrainingTermList = result.data;
            this.currentTerm = result.data.find((i) => i.IsCurrentTerm);
            if (this.USERMANAGER.isStudent && !this.currentTerm) {
              this.searchCondition.termId = "";
            } else {
              if (!!this.currentTerm) {
                this.searchCondition.termId = this.currentTerm.Id;
              } else if (this.vocationalTrainingTermList.length > 0) {
                this.searchCondition.termId =
                  this.vocationalTrainingTermList[0].Id;
              } else {
                this.searchCondition.termId = "";
              }
            }

            this.getListData();
          }
        }
      );
    },
    getSearchPageData(isDownload, courseId = null) {
      let pageData = {
        pageNumber: 1,
      };
      let additionalFilter = {
        CourseType: this.courseType,
        TermId: this.searchCondition.termId,
        GroupNumber: this.searchCondition.groupNumber,
      };

      let searchData = {
        pageSize: this.pageSize,
        keyWord: "",
        additionalFilter: additionalFilter,
        startDate: "",
        endDate: "",
      };

      if (!!isDownload) {
        if (!!courseId) {
          searchData.additionalFilter.CourseId = courseId;
        } else if (!!this.searchDate && this.searchDate.length == 2) {
          searchData.startDate = formatDate(this.searchDate[0]);
          searchData.endDate = formatDate(this.searchDate[1]);
        }
      }

      searchData = $.extend({}, pageData, searchData);
      return searchData;
    },
    getListData() {
      let pageData = this.getSearchPageData();
      this.loading = true;
      getcoursewareList(pageData)
        .then((result) => {
          if (!!result && result.success) {
            this.listData = result.data;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    customEventHandler(data) {
      if (data.action == "nav") {
        this.nav(data.data);
      }
    },
    onAdditional(name, index, row) {
      switch (name) {
        case "Download":
          this.onDownload(row);
          break;
      }
    },
    async onDownload(row = null) {
      if (!this.searchCondition.termId) {
        return;
      }

      if (!!row) {
        this.$set(row, "_isDownloading", true);
        this.isCourseDownloading = true;
      } else {
        this.isDownloading = true;
      }

      let courseId = !!row ? row.CourseId : null;
      let pageData = this.getSearchPageData(true, courseId);

      let info = await getTotalFilesInfo(pageData);
      if (!info || !info.success) {
        let msg = "";
        if (!!info && !!info.message) {
          msg = info.message;
        } else {
          msg = "课件下载失败";
        }
        this.$message.error(msg);

        if (!!row) {
          this.$set(row, "_isDownloading", false);
          this.isCourseDownloading = false;
        } else {
          this.isDownloading = false;
        }

        return;
      }

      let courseList = info.data.CourseList;
      if (courseList.length == 0) {
        this.$message({
          message: "选中的日期范围内没有任何课件文件可下载",
          type: "warning",
        });

        if (!!row) {
          this.$set(row, "_isDownloading", false);
          this.isCourseDownloading = false;
        } else {
          this.isDownloading = false;
        }

        return;
      }

      if (info.data.IsSeperated) {
        for (let i = 0; i < courseList.length; i++) {
          this.$notify.closeAll();
          let item = courseList[i];
          this.$notify({
            title: "文件下载中",
            message: `文件总大小${info.data.TotalSizeText}，需分课程下载。共${
              courseList.length
            }个课程，正在下载第${i + 1}个课程(${item.Value})。`,
            duration: 0,
          });
          //await sleep(3000);
          pageData.additionalFilter["CourseId"] = item.Key;

          let result = await downloadCourseware(pageData);

          if (!!result && result.success) {
            downloadFile(result);
          } else {
            if (!!result.message) {
              this.$message.error(result.message);
            }
          }
        }
        this.$notify.closeAll();
      } else {
        let result = await downloadCourseware(pageData);

        if (!!result && result.success) {
          downloadFile(result);
        } else {
          if (!!result.message) {
            this.$message.error(result.message);
          }
        }
      }

      if (!!row) {
        this.$set(row, "_isDownloading", false);
        this.isCourseDownloading = false;
      } else {
        this.isDownloading = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/courseware/coursewareList.vue